module.exports = __webpack_public_path__ + "frontend/images/faq/screen-payment-submit-def67b0ede236622032c20f81848a4a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/faq/screen-payment-submit.jpg
// module id = 347
// module chunks = 2